import { Book, Bot, HelpCircle, MessageCircle } from 'lucide-react';
import React from 'react';
import Navigation from './ZeronineHeader';
import Footer from './ZeronineFooter';

const HelpSupport = () => (
   <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50 pt-32 pb-20 px-4">
         <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
               <div className="inline-block px-4 py-2 bg-purple-100 rounded-full mb-6">
                  <span className="text-purple-600 font-bold">❓ HELP & SUPPORT</span>
               </div>
               <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">Help Center</h1>
               <p className="text-xl text-gray-600">Get help with ZeroNine AI features and GST filing</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
               <div className="bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-blue-300 hover:shadow-2xl transition-all text-center">
                  <Bot className="w-16 h-16 text-blue-600 mx-auto mb-4" />
                  <h3 className="text-2xl font-black text-gray-900 mb-4">AI Assistant</h3>
                  <p className="text-gray-600 mb-6">Get instant help from our AI assistant for accounting questions</p>
                  <button className="px-6 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all">
                     Chat with AI
                  </button>
               </div>

               <div className="bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-green-300 hover:shadow-2xl transition-all text-center">
                  <Book className="w-16 h-16 text-green-600 mx-auto mb-4" />
                  <h3 className="text-2xl font-black text-gray-900 mb-4">Documentation</h3>
                  <p className="text-gray-600 mb-6">Step-by-step guides and tutorials for all features</p>
                  <button className="px-6 py-3 bg-green-600 text-white rounded-xl font-bold hover:bg-green-700 transition-all">
                     View Docs
                  </button>
               </div>

               <div className="bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-purple-300 hover:shadow-2xl transition-all text-center">
                  <MessageCircle className="w-16 h-16 text-purple-600 mx-auto mb-4" />
                  <h3 className="text-2xl font-black text-gray-900 mb-4">Human Support</h3>
                  <p className="text-gray-600 mb-6">Talk to our expert support team for complex issues</p>
                  <button className="px-6 py-3 bg-purple-600 text-white rounded-xl font-bold hover:bg-purple-700 transition-all">
                     Contact Support
                  </button>
               </div>
            </div>

            <div className="bg-white rounded-3xl shadow-2xl p-8 border-2 border-gray-200">
               <h2 className="text-3xl font-black text-gray-900 mb-8 text-center">Frequently Asked Questions</h2>
               <div className="space-y-6">
                  {[
                     {
                        q: 'How do I set up GST filing?',
                        a: 'Go to Settings → GST Setup → Enter your GSTIN → Verify details → Start filing returns',
                     },
                     {
                        q: 'Can I migrate from Tally?',
                        a: 'Yes! Use our AI-powered migration tool to transfer all your data automatically',
                     },
                     {
                        q: 'How secure is my financial data?',
                        a: 'We use bank-level 256-bit encryption and are ISO 27001 certified with blockchain audit trails',
                     },
                     {
                        q: 'Do you offer training?',
                        a: 'Yes! We provide free video tutorials, live training sessions, and dedicated onboarding',
                     },
                  ].map((faq, idx) => (
                     <div key={idx} className="p-6 bg-gray-50 rounded-2xl border border-gray-200">
                        <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-3">
                           <HelpCircle className="w-6 h-6 text-blue-600" />
                           {faq.q}
                        </h3>
                        <p className="text-gray-700 ml-9">{faq.a}</p>
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </div>
      <Footer />
   </>
);

export default HelpSupport;
